import cloneDeep from 'lodash/cloneDeep';
import { isFunction, stringifyQueryParams } from '../../helpers';
import getPublishedStateHeader from '../../helpers/getPublishedStateHeader';

export const SUCCESS = 'AUDIENCE_ARTICLES_SUCCESS';
export const FAILURE = 'AUDIENCE_ARTICLES_FAILURE';
export const LOADING = 'AUDIENCE_ARTICLES_LOADING';
export const PRELOAD = 'AUDIENCE_ARTICLES_PRELOAD';

const initialState = {
  loaded: false,
  loading: false,
};

export default function audienceArticlesReducer(state = initialState, action) {
  switch (action.type) {
    case LOADING:
      return Object.assign({}, cloneDeep(state), {
        loading: true,
      });

    case PRELOAD: {
      const previousState = cloneDeep(state);
      previousState.data.displayed = previousState.data.displayed.concat(
        action.data.json.data?.displayed || [],
      );
      return Object.assign(previousState, {
        loading: false,
      });
    }

    case SUCCESS:
      return Object.assign(
        {},
        {
          loaded: true,
          loading: false,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    case FAILURE:
      return Object.assign(state, {
        error: true,
        loading: false,
        statusCode: action.data.statusCode,
      });

    default:
      return state;
  }
}

export function fetchAudienceArticlesSuccess(data) {
  return { type: SUCCESS, data };
}

export function loadAudienceArticlesSuccess(data) {
  return { type: PRELOAD, data };
}

export function fetchAudienceArticlesFailure(data) {
  return { type: FAILURE, data };
}

export function fetchAudienceArticlesLoading() {
  return { type: LOADING };
}

export function fetchAudienceArticlesAction(
  { page = 1, count = 20 } = {},
  callback,
) {
  return function (dispatch, getState, { Api, i18n, qs }) {
    dispatch(fetchAudienceArticlesLoading());

    const {
      pageConfig: {
        previewMode,
        siteId,
        location: { search },
      },
    } = getState();

    const basicView = page !== 1;

    let query = stringifyQueryParams({ page, count, basicView });
    if (search) {
      query += '&' + search.slice(1);
    }

    return Api()
      .service('ContentService')
      .version('v1')
      .setup({
        headers: {
          'Accept-Language': i18n.language,
          'Published-State': getPublishedStateHeader(previewMode),
        },
      })
      .fetchAudienceArticles({ siteId, query })
      .then((response) => {
        if (isFunction(callback)) {
          callback();
        }

        if (response.statusCode === 200) {
          if (basicView) {
            return dispatch(loadAudienceArticlesSuccess(response));
          }

          return dispatch(fetchAudienceArticlesSuccess(response));
        } else {
          return dispatch(fetchAudienceArticlesFailure(response));
        }
      });
  };
}
